import React, { FC, ReactNode } from 'react'
import ReactModal from 'react-modal'
import { styles, ModalHeader, ModalBody, ModalFooter } from './styles'

export interface ModalProps {
  modal: {
    title: string
    content: ReactNode
    footer?: ReactNode
  }
  isOpen: boolean
  onClose?: () => {}
  onSubmit?: () => {}
}

const Modal: FC<ModalProps> = ({ modal, isOpen, onClose, onSubmit }) => (
  // @ts-ignore
  <ReactModal isOpen={isOpen} style={styles}>
    <ModalHeader>{modal.title}</ModalHeader>
    <ModalBody>{modal.content}</ModalBody>
    {modal.footer && <ModalFooter>{modal.footer}</ModalFooter>}
  </ReactModal>
)

Modal.defaultProps = {
  isOpen: false
}

export default Modal

export { Modal }
